"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    green1: "#00e65a",
    green2: "#00cc50",
    green3: "#00a641",
    blue1: "#2469ff",
    blue2: "#1d54ca",
    blue3: "#12347f",
    blue4: "#0d275b",
    orange1: "#ff9817",
    orange2: "#ff5e3d",
    orange3: "#cc4b31",
    cherry1: "#d13565",
    cherry2: "#ad2b53",
    cherry3: "#801f3c",
    teal1: "#58d5cf",
    teal2: "#35c3bd",
    teal3: "#12b3ac",
    teal4: "#089892",
    teal5: "#089892",
    grey1: "#f9f7f6",
    grey2: "#f7f5f3",
    grey3: "#dbd5cd",
    grey4: "#b5b0a9",
    grey5: "#928d88",
    grey6: "#807c78",
    grey7: "#706d69",
    grey8: "#5f5d59",
    grey9: "#4f4d4a",
    grey10: "#3e3c39",
    grey11: "#2d2b28",
    white: "#ffffff",
    VRBackground: "#0b032e",
    VRText: "#fff",
};
